import React, {useEffect, useState} from "react";
import {Col} from "antd";
import _ from "lodash";
import {ShiftManagementFilterPropTypes} from "./ShiftManagementComponentPropTypes";
import {
    CityFilter,
    CompanyFilter,
    DatePickerWithPeriod,
    SearchText,
    SubCompanyFilter,
    SubCompanyWorkTypeFilter
} from "../../_defaultComponents/FilterComponents";

const ShiftManagementFilters = ({
    setCurrentPage,
    filters,
    setFilters,
    setWorkType,
    workType,
    isSnapshot = false
}) => {
    const [city, setCity] = useState(filters.city);
    const [company, setCompany] = useState(filters.company);
    const [subcompany, setSubcompany] = useState(filters.subcompany);
    const [period, setPeriod] = useState(filters.period);
    const [startDate, setStartDate] = useState(filters.startDate);
    const [endDate, setEndDate] = useState(filters.endDate);
    const [searchText, setSearchText] = useState(filters.searchText);

    useEffect(() => {
        if (city !== "") {
            setCompany(undefined);
            setSubcompany(undefined);
        }
    }, [city]);
    useEffect(() => {
        setSubcompany(undefined);
    }, [company]);

    useEffect(() => {
        setCurrentPage(1);
    }, [city, company, subcompany, period, startDate, endDate, searchText]);

    useEffect(() => {
        const newFilters = {
            city,
            company,
            subcompany,
            period,
            startDate,
            endDate,
            searchText,
            courier: filters.courier,
            pool: filters.pool
        };
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [city, company, subcompany, period, startDate, endDate, searchText, workType]);

    return (
        <React.Fragment>
            {!isSnapshot && (
                <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                    <SubCompanyWorkTypeFilter
                        showAllOption={false}
                        value={workType}
                        onChange={value => {
                            setWorkType(value);
                            setCurrentPage(1);
                        }}
                    />
                </Col>
            )}
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <CityFilter value={city} onChange={setCity} />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <CompanyFilter value={company} onChange={setCompany} />
            </Col>

            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <SubCompanyFilter
                    value={subcompany}
                    onChange={setSubcompany}
                    company={company}
                    disabled={!(Boolean(company) && !["pool", "all"].includes(company))}
                />{" "}
            </Col>

            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <SearchText value={searchText} onChange={setSearchText} />
            </Col>
            <Col xs={48} sm={40} md={32} lg={20} xl={16}>
                <DatePickerWithPeriod
                    period={period}
                    setPeriod={setPeriod}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            </Col>
        </React.Fragment>
    );
};

export default ShiftManagementFilters;
